module.exports = __webpack_public_path__ + "static/media/upload_file.4e771ac6.svg";